import React, { useRef, useState, useEffect, useLayoutEffect } from 'react';
import {
  Box,
  HeadingText,
  StackItem,
  StackLayout,
  queryHelpers,
  useMediaQuery,
} from '@leagueplatform/genesis-core';
import { PageHeaderBackground } from '@leagueplatform/web-common-components';
import { BackButtonArrow } from 'components/back-button-arrow/back-button-arrow.component';

export const PageHeader = ({
  headingText,
  showBackButton = true,
}: {
  headingText?: string;
  showBackButton?: boolean;
}) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [contentHeight, setContentHeight] = useState(100);
  const isLaptopDown = useMediaQuery(queryHelpers.down('laptop'));
  const pageHeaderBackgroundHeightPadding = isLaptopDown ? 80 : 100;

  useLayoutEffect(() => {
    const reportWindowSize = () => {
      setContentHeight(contentRef?.current?.clientHeight ?? contentHeight);
    };
    if (contentHeight !== undefined)
      window.addEventListener('resize', reportWindowSize);
    return () => window.removeEventListener('resize', reportWindowSize);
  }, [contentHeight]);

  useEffect(() => {
    if (contentRef?.current?.clientHeight)
      setContentHeight(contentRef.current.clientHeight);
  }, []);

  return (
    <Box
      css={{
        marginTop: '$two',
        marginBottom: '$two',
        '@laptop': {
          marginTop: '56px',
          marginBottom: '56px',
        },
        '@desktop': {
          marginTop: '56px',
          marginBottom: '56px',
        },
      }}
    >
      <PageHeaderBackground
        height={`${contentHeight + pageHeaderBackgroundHeightPadding / 2}px`}
        pageHeaderBackgroundHeight={`${
          contentHeight + pageHeaderBackgroundHeightPadding
        }px`}
      >
        <StackLayout>
          <StackItem
            horizontalAlignment="start"
            verticalAlignment="top"
            ref={contentRef}
          >
            <StackLayout
              orientation={{
                '@initial': 'vertical',
                '@desktop': 'horizontal',
                '@laptop': 'horizontal',
              }}
            >
              {showBackButton && (
                <BackButtonArrow
                  css={
                    isLaptopDown
                      ? { marginBottom: '$half' }
                      : { marginTop: '$half', marginRight: '$one' }
                  }
                  analyticsEventProps={{
                    screen_name: headingText,
                  }}
                />
              )}

              {headingText ? (
                <HeadingText
                  level="1"
                  size={{
                    '@initial': 'xl',
                    '@laptop': 'xxl',
                    '@desktop': 'xxl',
                  }}
                >
                  {headingText}
                </HeadingText>
              ) : (
                <Box css={{ height: '$three' }} />
              )}
            </StackLayout>
          </StackItem>
        </StackLayout>
      </PageHeaderBackground>
    </Box>
  );
};
